// Keep existing numeric defaults and row alignment used by the API/report model.
export function buildExtendedAnswers(values, j, finalSelectReduce, finalSelectFuture, mode, nonKpi) {
  return {
    productSell:values?.sellProductTo?.[j]?.map(item => item?.productSell ?? "") ?? [],
    industrySell:values?.sellProductTo?.[j]?.map(item => item?.industrySell ?? "") ?? [],
    companySell:values?.sellProductTo?.[j]?.map(item => item?.companySell ?? "") ?? [],
    productBuy:values?.buyProductFrom?.[j]?.map(item => item?.productBuy ?? "") ?? [],
    companyBuy:values?.buyProductFrom?.[j]?.map(item => item?.companyBuy ?? "") ?? [],
    industryBuy:values?.buyProductFrom?.[j]?.map(item => item?.industryBuy ?? "") ?? [],
    capacity_add: values?.capacity_add?.[j] ?? 0,
    capacity_sub: values?.capacity_sub?.[j] ?? 0,
    newProductLine:values?.newProductLine?.[j] ?? "",
    electricity_add: values?.electricity_add?.[j] ?? 0,
    electricity_sub: values?.electricity_sub?.[j] ?? 0,
    water_add: values?.water_add?.[j] ?? 0,
    water_sub: values?.water_sub?.[j] ?? 0,
    ro_add: values?.ro_add?.[j] ?? 0,
    ro_sub: values?.ro_sub?.[j] ?? 0,
    country_Import:values?.bigImportTo?.[j]?.map(item => item?.country_Import ?? "") ?? [],
    isSelectReduce:finalSelectReduce,
    isSelectFuture:finalSelectFuture,
    solarcellCapacity:values?.solarcellCapacity?.[j] ?? 0,
    waterUsage:values?.waterUsage?.[j] ?? 0,
    electricityUsage:values?.electricityUsage?.[j] ?? 0,
    wasteWaterVolume:values?.wasteWaterVolume?.[j] ?? 0,
    capacity_plan:values?.capacity_plan?.[j],
    importTax: mode === "edit" ? values?.importTax?.[j] :
      (nonKpi && values?.importTax?.[j] == null ? null : values?.importTax?.[j] === 'true'),
    industryTaxImport:values?.TaxEffect?.[j]?.map(item => item?.industryTaxImport ?? "") ?? [],
    productTaxImport:values?.TaxEffect?.[j]?.map(item => item?.productTaxImport ?? "") ?? [],
    estimatedCost:values?.estimatedCost?.[j] ?? 0,
    remark_ieat:values?.remark_ieat?.[j] || "",
    interestDetail : values?.interestDetail?.[j] || "",
    smesInterest : values?.smesInterest?.[j] || "",
    innovationInterest : values?.innovationInterest?.[j] || "",

  };
}

// A missing optional yes/no answer must not become an explicit "No" on edit/view.
export const readBooleanAnswer = value => value == null ? undefined : value === true || value === "true";
